import { BarChart, Bar, XAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { useSubscriptionCounts } from '@/hooks/dashboardHooks';

const MONTH_LABELS: Record<string, string> = {
  JANUARY: 'Jan',
  FEBRUARY: 'Feb',
  MARCH: 'Mar',
  APRIL: 'Apr',
  MAY: 'May',
  JUNE: 'Jun',
  JULY: 'Jul',
  AUGUST: 'Aug',
  SEPTEMBER: 'Sep',
  OCTOBER: 'Oct',
  NOVEMBER: 'Nov',
  DECEMBER: 'Dec',
};

const SubscriptionsBarChart = () => {
  const { data: chartData } = useSubscriptionCounts();

  const formattedChartData = chartData
    ? Object.entries(chartData).map(([month, count]) => ({
        month: MONTH_LABELS[month] ?? month,
        count,
      }))
    : [];

  return (
    <>
      <Card className="w-full">
        <CardHeader>
          <CardTitle>Monthly Subscriptions</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="overflow-auto">
            <ResponsiveContainer height={300} minWidth={400}>
              <BarChart
                data={formattedChartData}
                margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="month" />
                {/* <YAxis allowDecimals={false} /> */}
                <Tooltip />
                <Bar dataKey="count" fill="#264308" barSize={35} />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </CardContent>
      </Card>
    </>
  );
};

export default SubscriptionsBarChart;
